
import Litepicker from 'litepicker';
import 'litepicker/dist/plugins/mobilefriendly';
var selectedDates;

/** numeros de passageiros e idades */
var minPassengers=0;
var maxPassengers=10;
var passengers = 0;

var formCotationController = function () {
    
    var dates = function() {
        selectedDates = new Litepicker({
            element: document.getElementById('departure'),
            elementEnd: document.getElementById('arrival'),
            buttonText: {
                "apply":"Continuar",
                "cancel":"Cancelar"
            },
            tooltipText: {
                one: 'Dia',
                other: 'Dias'
            },
            singleMode: false,
            allowRepick: true,
            minDate:new Date()-1,
            format:'DD/MM/YYYY',
            plugins: ['mobilefriendly'],
            lang:'pt-BR',
        });
    }

    var ages = function(){
        let group = document.querySelectorAll(".ages");
        for(let i=0; i<group.length; i++){
            group[i].querySelector('.btn-up').addEventListener("click", function(e) {
                e.preventDefault();
                passengerUp($(this).closest('.ages').find('input'));
            });
            group[i].querySelector('.btn-down').addEventListener("click", function(e) {
                e.preventDefault();
                passengerDown($(this).closest('.ages').find('input'));
                
            });

            let el = getInput(group[i]);
            let val = parseInt(el.value);
            passengers += val;
            
        }

        function passengerUp(el){
            let val = parseInt(el.val());
            if(val+1<=maxPassengers){
                if(passengers+1<=maxPassengers){
                    passengers +=1;
                    el.val(val+1);
                }
            }
            updateClassPassager();
        }
        function passengerDown(el){
            let val = parseInt(el.val());
            if(val-1>=minPassengers){
                if(passengers-1>=minPassengers){
                    passengers -=1;
                    el.val(val-1);
                }
            }
            updateClassPassager();
        }

        function updateClassPassager(){
            if(passengers>0){
                $("#ages").val(passengers + ' Passageiro(s)');
            }else{
                $("#ages").val('Selecione');
            }
            
        }


        function getInput(el){
            
            return (el.parentNode).querySelector('input');
        }

        updateClassPassager();
    }

    var actionsOpenClose = function() {
        $(".selectAges .save").on('click',function () {
            $('.selectAges').hide();
            window.loadGlobal(false);
        });
        $("#ages").on('click',function () {
            $('.selectAges').show();
            window.loadGlobal(true, false);
        });
        
    }
    
    return {
        init: function() {
            dates();
            ages();
            actionsOpenClose();
        }
    };
}();
    
$(function () {
    formCotationController.init();
});
